import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex flex-col justify-center items-center",
  "data-testid": "empty-table"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "mt-[32px]"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-[24px] text-Text/text_high font-gordita-medium" }, "No Results Found", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 3,
  class: "mt-[24px] text-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mt-[40px] mb-[32px] text-[24px] text-Text/text_high font-gordita-medium" }, "No Agents", -1)
const _hoisted_10 = { class: "mt-[12px] text-Text/text_medium gordita-regular-14" }
const _hoisted_11 = { class: "block" }

import empty_search from '@/assets/images/agents/empty_search.svg';
import { IncrediButton } from 'incredi-ui';
import empty_agents from '@/assets/images/agents/no_agents.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'empty-table-placeholder',
  props: {
    searchItemsName: null,
    hasFiltersApplied: { type: Boolean },
    disabledDefaultMessagePrefix: { type: Boolean, default: false }
  },
  emits: ["clearFilters"],
  setup(__props: any, { emit }: { emit: ({ (e: 'clearFilters'): void }), expose: any, slots: any, attrs: any }) {


const clearFilters = () => {
  emit('clearFilters');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.hasFiltersApplied)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(empty_search),
          alt: "empty-search"
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _unref(empty_agents),
          alt: "empty_agents"
        }, null, 8, _hoisted_3)),
    (__props.hasFiltersApplied)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          (__props.hasFiltersApplied)
            ? (_openBlock(), _createBlock(_unref(IncrediButton), {
                key: 0,
                design: "primary-green",
                size: "small",
                rounded: true,
                class: "text-[13px] text-center mt-[12px] font-gordita-medium",
                onClick: clearFilters
              }, {
                default: _withCtx(() => [
                  (!__props.disabledDefaultMessagePrefix)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Show All " + _toDisplayString(__props.searchItemsName), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.searchItemsName), 1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('generic.emptyPlaceholder.noAgentsFound.a')), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('generic.emptyPlaceholder.noAgentsFound.b')), 1)
          ])
        ]))
  ]))
}
}

})